export default "__VITE_ASSET__BfPycLRu__"